<template>
  <div class="login_container">
    <div class="login_box">
      <!-- LOGO -->
      <div class="avatar_box">
        <!-- <img src="../assets/logo.png" alt /> -->
        <img src="../assets/knee.png" alt />
      </div>
      <!-- <h2 class="title">全心脏建模在线平台</h2> -->
      <h2 class="title">膝关节软骨建模平台</h2>
      <!-- 表单 -->
      <el-form
        ref="LoginFormRef"
        :model="loginForm"
        label-width="0"
        :rules="LoginFormRules"
        class="login_form"
      >
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-user"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password"></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="login">登录</el-button>
          <el-button type="info" @click="resetLoginForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      LoginFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    resetLoginForm() {
      this.$refs.LoginFormRef.resetFields();
    },
    login() {
      this.$refs["LoginFormRef"].validate(async valid => {
        if (valid) {
          // const { data } = await this.$http.post("user/login", this.loginForm);
          // if (data.status === 100) {
          //   window.sessionStorage.setItem("token", data.data.token);
          //   window.sessionStorage.setItem("username", data.data.username);
          //   this.$router.push("/home");
          //   this.$message({
          //     message: "登陆成功",
          //     type: "success"
          //   });
          // }
           this.$message({
              message: "密码错误",
              type: "error"
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login_container {
  background-color: #2b4b6b;
  height: 100%;
}

.login_box {
  width: 450px;
  height: 350px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.avatar_box {
  width: 130px;
  height: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}
.title {
  position: absolute;
  bottom: 190px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.btns {
  display: flex;
  justify-content: flex-end;
}
</style>>

